<template>
  <div class="migration-banner" :style="{ backgroundColor: bgColor }">
    <div class="migration-banner__content">
      <alarm-icon class="migration-banner__icon" :color="textColor" />
      <span class="migration-banner__text" :style="{ color: textColor }">
        {{ $t('migration.banner_message', { date: 'December 31, 2025', productType }) }}
      </span>
    </div>
    <el-button
      v-if="novaOrgId"
      type="primary" 
      size="small" 
      class="migration-banner__button"
      @click="goToElsaBusinessInsights"
    >
      {{ $t('migration.banner_button', { productType }) }}
    </el-button>
  </div>
</template>
<script>
import AlarmIcon from "@/components/common/icons/AlarmIcon.vue";
export default {
  name: 'MigrationBanner',
  components: {
    AlarmIcon
  },
  props: {
    novaOrgId: {
      type: Number,
      required: true
    },
    productType: {
      type: String,
      default: 'ELSA Business'
    }
  },
  data() {
    return {
      forceShowErrorWarning: true
    }
  },
  computed: {
    isBeforeQ4() {
      if (this.forceShowErrorWarning) {
        return false;
      }

      const now = new Date();
      const cutoffDate = new Date('2025-09-30');
      return now <= cutoffDate;
    },
    textColor() {
      return this.isBeforeQ4 ? '#78350F' : '#991B1B';
    },
    bgColor() {
      return this.isBeforeQ4 ? '#FEF3C7' : '#FEF2F2';
    }
  },
  methods: {
    goToElsaBusinessInsights() {
      window.open(`${process.env.VUE_APP_NOVA_DASHBOARD_URL}/organizations/${this.novaOrgId}`, '_blank');
    },
  }
};
</script>
<style lang="scss" scoped>
.migration-banner {
  display: flex;
  align-items: center;
  padding: 12px 20px;

  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    color: #78350F;
    font-size: 14px;
    font-weight: 500;
  }

  &__button {
    background: #4235FF;
    border: none;
    margin-left: auto;
    border-radius: 10px;
  }
}
</style>
